/**************************************************
 * Nombre:       Formulario_Soporte_Externo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, Google, Title} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSUSUARIOS} from "../../Constantes";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";

const Formulario_Soporte_Externo = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombres es requerido'}
                    />
                </Grid>



                <Grid container size={6}>
                    <IngresoSelect Icono={BadgeOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo de cuenta'} dato={'correo'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Title} nombre={'Asunto'} dato={'asunto'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Descripcion del asunto'} dato={'descripcion'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 0.5}}>
                    <Typography>Imagen o captura de pantalla (opcional)</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagen dato={'img'} {...props} ancho={2} alto={1}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Soporte_Externo